<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white fixed-header-position">
        ارزشیابی طرف معامله
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding text-center">
      <q-chip :size="$q.screen.lt.md?'sm':'md'" clickable @click="filterByValueKind(undefined)" color="indigo" icon="star" text-color="white"
              label="تمام مشتریان" square>
        <q-badge class="q-ml-xs" :label="customerOptions.length" color="red"/>
      </q-chip>
      <q-chip :size="$q.screen.lt.md?'sm':'md'" clickable color="indigo" icon="star" text-color="white" v-for="(item, index) in getSummarizeReport"
              :key="index"
              square :label="item.valueKind" @click="filterByValueKind(item)">
        <q-badge class="q-ml-xs" :label="item.valueCount" color="red"/>
      </q-chip>
    </q-card-section>

    <q-table
        :data="customerOptions"
        row-key="Cs_ID"
        wrap-cells
        flat
        :hide-header="$q.screen.lt.md"
        :pagination="pagination"
        :filter="filter">
      <template v-slot:top>
        <div class="row">
          <vue-json-to-csv
              :json-data="customerOptions"
              v-if="customerOptions && customerOptions.length>0 && $store.state.roles.some(v=>['admin','can_download_list'].includes(v))">
            <q-btn label="دانلود" icon="download" color="blue" flat class="q-ml-sm">
              <download-csv
                  name="customersList"
                  :data="customerOptions">
                <span></span>
              </download-csv>
              <q-tooltip>
                دانلود گزارش
              </q-tooltip>
            </q-btn>
          </vue-json-to-csv>
        </div>
      </template>
      <template v-slot:header>
        <tr class="text-subtitle2">
          <td class="text-center">کد طرف معامله</td>
          <td class="text-center">عنوان طرف معامله</td>
          <td class="text-center">استان</td>
          <td class="text-center">شهر</td>
          <td class="text-center">
            ارزش سازمانی
          </td>
          <td class="text-center">
            تعداد خرید
          </td>
          <td class="text-center">
            تعداد کالا
          </td>
          <td class="text-center">
            آخرین خرید(روز)
          </td>
          <td class="text-center">
            مبلغ خرید سال
          </td>
          <td class="text-center">
            طول ارتباط (روز)
          </td>
          <td class="text-center">
            میانگین خرید در ماه
          </td>
          <td>
            ارزش
          </td>
        </tr>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props" class="my-class" v-if="!$q.screen.lt.md">
          <td class="text-center">
            <q-chip :icon="props.row.ValidInformation===1?'check':'person'" clickable @click="showDetails(props.row)"
                    square color="indigo-9" text-color="white">
              {{ props.row.Cs_Code }}
            </q-chip>
          </td>
          <td>
            {{ props.row.Cs_Name }}
          </td>
          <td class="text-center">
            {{ props.row.State_Name }}
          </td>
          <td class="text-center">
            {{ props.row.City_Name }}
          </td>
          <td class="text-center">
            <q-chip color="red" text-color="white" square
                    icon="star">
              {{ props.row.ValueKind }}
            </q-chip>
          </td>
          <td class="text-center">
            {{ props.row.SaleCount }}
          </td>
          <td class="text-center">
            {{ props.row.Sale_ItemCount }}
          </td>
          <td class="text-center">
            <q-chip color="deep-orange-10" text-color="white" square
                    icon="calendar_today">
              {{ props.row.LastSaleDays !== 0 ? `${props.row.LastSaleDays}` : `امروز` }}
            </q-chip>
          </td>
          <td class="text-center">
            <q-chip color="green" text-color="white" square
                    icon="attach_money">
              {{ props.row.Sale_Pay | toLoalString }} ریال
            </q-chip>
          </td>
          <td class="text-center">
            <q-chip color="deep-orange-10" text-color="white" square
                    icon="calendar_today">
              {{ props.row.RelationLength }}
            </q-chip>
          </td>
          <td class="text-center">
            {{ props.row.InMonth }}
          </td>
          <td>
            <q-circular-progress
                show-value
                font-size="12px"
                :value="props.row.CustomerValue"
                size="30px"
                :thickness="0.22"
                color="orange"
                track-color="orange-2"
                :max="max"
                :min="min">
                    <span class="text-bold">
                      {{ props.row.CustomerValue }}
                    </span>
            </q-circular-progress>
          </td>
        </q-tr>
        <q-tr :props="props" class="my-class" v-if="$q.screen.lt.md">
          <q-td>
            <div class="row">
              <div class="col-xs-12">
                <q-card flat>
                  <q-card-section class="text-center no-padding">
                    <q-circular-progress
                        show-value
                        font-size="12px"
                        :value="props.row.CustomerValue"
                        size="80px"
                        :thickness="0.22"
                        color="orange"
                        track-color="orange-2"
                        :max="max"
                        :min="min"
                    >
                    <span class="text-bold text-h6">
                      {{ props.row.CustomerValue }}
                    </span>
                    </q-circular-progress>
                  </q-card-section>
                  <q-card-section class="no-padding text-center">
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" color="red" text-color="white" square
                            icon="star">
                      {{ props.row.ValueKind }}
                    </q-chip>
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" square color="deep-purple-9" text-color="white"
                            flat>
                      <q-icon name="check" v-if="props.row.ValidInformation===1"/>
                      {{ props.row.Cs_Name }}
                      <q-badge color="red-14" class="q-ml-xs">{{ props.row.Cs_Code }}</q-badge>
                    </q-chip>
                  </q-card-section>
                  <q-card-section class="no-padding text-center">
                    <q-chip  :size="$q.screen.lt.md?'sm':'md'" :label="props.row.State_Name" square icon-right="location_city"/>
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" :label="props.row.City_Name" square icon-right="location_city"/>
                  </q-card-section>
                  <q-card-section class="no-padding text-center">
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" color="brown"
                            text-color="white" square flat>
                      <q-icon size="sm" name="functions"/>
                      تعداد خرید :{{ props.row.SaleCount }}
                    </q-chip>
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" color="brown-14"
                            text-color="white" square flat>
                      <q-icon size="sm" name="functions"/>
                      {{ props.row.LastSaleDays !== 0 ? `آخرین خرید ${props.row.LastSaleDays}روز` : `امروز` }}
                    </q-chip>
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" color="blue-grey" text-color="white" square
                            icon="attach_money">
                      تعداد کالا:
                      {{ props.row.Sale_ItemCount }}
                    </q-chip>
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" color="deep-orange-5" text-color="white" square
                            icon="attach_money">
                      طول ارتباط:
                      {{ props.row.RelationLength }}روز
                    </q-chip>
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" color="grey" text-color="white" square
                            icon="attach_money">
                      میانگین خرید ماهیانه:
                      {{ props.row.InMonth }}
                    </q-chip>
                  </q-card-section>
                  <q-card-section class="no-padding text-center">
                    <q-chip :size="$q.screen.lt.md?'sm':'md'" color="green" text-color="white" square
                            icon="attach_money">
                      {{ props.row.Sale_Pay | toLoalString }} ریال
                    </q-chip>
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-2">
                <div class="row justify-center items-center full-height">
                </div>
              </div>
            </div>
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showCustomerFullInfo">
      <CustomerInfo :selectedCustomer.sync="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";
import VueJsonToCsv from 'vue-json-to-csv'

export default {
  name: "CustomerRFM",
  components: {CustomerInfo, VueJsonToCsv},
  data() {
    return {
      pagination: {
        rowsPerPage: 50
      },
      showCustomerFullInfo: false,
      selectedCustomer: '',
      customerList: [],
      customerOptions: [],
      filter: '',
      min: 0,
      max: 100,
      selectedCompanies: [],
      companyList: [],
      selectedGroups: [],
      stateList: [],
      stateListOptions: [],
      cityList: [],
      cityListOptions: [],
      selectedStates: [],
      selectedCities: []
    }
  },
  methods: {
    ...mapActions({
      LoadData: 'Dashboard/getRFM',
      LoadCustomerInfo: 'Customers/get_customer_info'
    }),
    filterByValueKind(item) {
      if (item === undefined) {
        this.customerOptions = this.customerList
      } else {
        this.customerOptions = this.customerList.filter(v => v.ValueKind === item.valueKind)
      }

    },
    showDetails(row) {
      this.LoadCustomerInfo(row.Cs_ID).then((res) => {
        if (res.data && res.data.length > 0) {
          this.selectedCustomer = res.data[0]
          this.showCustomerFullInfo = true
        }
      })
    },
    stateFilterFn(val, update) {
      if (val === '') {
        update(() => {
          this.stateListOptions = this.stateList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.stateListOptions = this.stateList.filter(v => v.toLowerCase().indexOf(needle) > -1)
      })
    },
    cityFilterFn(val, update) {
      if (val === '') {
        update(() => {
          this.cityListOptions = this.cityList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.cityListOptions = this.cityList.filter(v => v.toLowerCase().indexOf(needle) > -1)
      })
    },
  },
  computed: {
    getCompanyList() {
      return [...new Set(this.customerList.map(item => item.CompName).filter(item => item !== null))]
    },
    getGroups() {
      return [...new Set(this.customerList.map(item => item.ValueKind).filter(item => item !== null))]
    },
    getSummarizeReport() {
      return this.lodash.chain(this.customerOptions)
          .groupBy("ValueKind")
          .map(function (v, i) {
            return {
              valueKind: i,
              valueCount: v.length
            }
          })
          .value();
    }
  },
  watch: {
    selectedCompanies: function (value) {
      if (value.length > 0) {
        this.customerOptions = this.customerList
            .filter(item => item.CompName !== null && value.includes(item.CompName))
        if (this.selectedGroups.length > 0) {
          this.customerOptions = this.customerOptions
              .filter(item => this.selectedGroups.includes(item.ValueKind))
        }
      } else {
        if (this.selectedGroups.length > 0) {
          this.customerOptions = this.customerList
              .filter(item => this.selectedGroups.includes(item.ValueKind))
        } else {
          this.customerOptions = this.customerList
        }
      }
    },
    selectedGroups: function (value) {
      if (value.length > 0) {
        this.customerOptions = this.customerList
            .filter(item => item.ValueKind !== null && value.includes(item.ValueKind))
        if (this.selectedCompanies.length > 0) {
          this.customerOptions = this.customerOptions
              .filter(item => this.selectedCompanies.includes(item.CompName))
        }
      } else {
        if (this.selectedCompanies.length > 0) {
          this.customerOptions = this.customerList
              .filter(item => this.selectedCompanies.includes(item.CompName))
        } else {
          this.customerOptions = this.customerList
        }
      }
    },
    selectedStates: function (value) {
      if (value.length > 0) {
        this.customerOptions = this.customerList
            .filter(item => item.State_Name !== null && value.includes(item.State_Name))
        if (this.selectedCompanies.length > 0) {
          this.customerOptions = this.customerOptions
              .filter(item => this.selectedCompanies.includes(item.CompName))
        }
      } else {
        if (this.selectedCompanies.length > 0) {
          this.customerOptions = this.customerList
              .filter(item => this.selectedCompanies.includes(item.CompName))
        } else {
          this.customerOptions = this.customerList
        }
      }
    },
    selectedCities: function (value) {
      if (value.length > 0) {
        this.customerOptions = this.customerList
            .filter(item => item.City_Name !== null && value.includes(item.City_Name))
        if (this.selectedCompanies.length > 0) {
          this.customerOptions = this.customerOptions
              .filter(item => this.selectedCompanies.includes(item.CompName))
        }
      } else {
        if (this.selectedCompanies.length > 0) {
          this.customerOptions = this.customerList
              .filter(item => this.selectedCompanies.includes(item.CompName))
        } else {
          this.customerOptions = this.customerList
        }
      }
    },
    filter: function (value) {
      if (value === '') {
        this.selectedGroups = []
      }
    }
  },
  created() {
    this.LoadData().then((res) => {
      this.customerList = res
      this.customerOptions = this.customerList
      this.stateList = this.lodash.uniq(this.customerList.map(item => item.State_Name))
      this.cityList = this.lodash.uniq(this.customerList.map(item => item.City_Name))

      this.stateListOptions = this.stateList
      this.cityListOptions = this.cityList
    })
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}

.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000
}
</style>
